<template>
    <div class="qksm qksm5" v-if="num(T5.总计)==0">
        <h4>五、关于{{$store.state.divData.divname}}2022年一般公共预算当年拨款情况说明</h4>
        <p>{{$store.state.divData.divname}}2022年没有使用一般公共预算拨款安排的支出。</p>
    </div>
    <template v-else>
        <div class="qksm qksm5">
            <h4>五、关于{{$store.state.divData.divname}}2022年一般公共预算当年拨款情况说明</h4>
            <h4>（一）一般公共预算当年拨款规模变化情况。</h4>
            <div class="nogap">
                <p>
                    {{$store.state.divData.divname}}2022年一般公共预算当年拨款{{isMoney(T5.总计)}}万元,
                    <span class="hide_pdf">
                        （去年预算数<reason type="money" classname="qksm money" name="T5总计last" v-model:value="T5['总计last']"></reason>万元）
                    </span>
                    <span v-if="T5.总计==num(T5['总计last'])">
                        与上年相同。
                    </span>
                    <span v-else>
                        比上年{{growthValueText(T5.总计, num(T5['总计last']))}}万元，
                        <span v-if="num(T5['总计last'])==0">
                            去年无预算。
                        </span>
                        主要是
                        <reason type="textarea" classname="qksm widest" name="T5原因" v-model:value="qksm['T5原因']"></reason>
                    </span>
                </p>
            </div>
            <div id="myChart5" class="echart" v-if="(!isPdf && $parent.isData) || isPdf"></div>
        </div>
        <div class="qksm qksm5">
            <h4>（二）一般公共预算当年拨款结构情况。</h4>
            <div class="nogap">
                <p>
                    <template v-for="(item, idx) in T5.leiItems">
                        {{item.name.replace("支出", "")}}（类）支出{{isMoney(item.value)}}万元，占{{getPercentValue(T5.leiItems.map(e=>e.value), idx, 2)}}{{idx==T5.leiItems.length-1?'。':'；'}}
                    </template>
                </p>
            </div>
            <div id="myChart6" class="echart" v-if="(!isPdf && $parent.isData) || isPdf"></div>
        </div>
        <div class="qksm qksm5">
            <h4>（三）一般公共预算当年拨款具体使用情况。</h4>
            <div class="nogap">
                <p v-for="(item, idx) in T5.items">
                    {{idx+1}}、{{item.lei.replace("支出", "")}}{{item.kuan}}{{item.xiang}}2022年预算数为{{isMoney(item.value)}}万元，
                    <span class="hide_pdf">
                        （去年预算数<reason type="money" classname="qksm money" :name="'T5last'+item.code" v-model:value="qksm['T5last'+item.code]"></reason>万元）
                    </span>
                    <span v-if="item.value==num(qksm['T5last'+item.code])">
                        与上年相同。
                    </span>
                    <span v-else>
                        比上年{{growthValueText(item.value, qksm['T5last'+item.code])}}万元，
                        <span v-if="(qksm['T5last'+item.code])==0">
                            去年无预算
                        </span>
                        <span v-else>
                            {{growthRatioText(item.value, qksm['T5last'+item.code])}}
                        </span>
                        。主要是
                        <reason type="textarea" classname="qksm widest" :name="'T5原因'+item.code" v-model:value="qksm['T5原因'+item.code]"></reason>
                    </span>
                </p>
            </div>
        </div>
    </template>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm5",
        data() {
            var qksm = this.$store.state.divData.qksm;
            if (qksm['T5总计last'])
                this.T5['总计last'] = qksm['T5总计last'];
            for (let item of this.T5.items) {
                qksm['T5last' + item.code] = this.pickOneOf(qksm['T5last' + item.code], item.lastvalue)
            }
            return {
                isPdf: this.$parent.isPdf,
                qksm: qksm,
            }
        },
        props: {
            T5: {
                type: Object,
                default: "",
            },
        },
        components: {
            reason,
        },
        computed: {
            总计last() {
                return this.isMoney(this.T5.总计last)
            }
        },
        watch: {
            总计last() {
                this.$parent.isChart()
            }
        },
    };
</script>